import { c as _c } from "react/compiler-runtime";
import type { SVGProps } from 'react';
const PointsGradient = props => {
  const $ = _c(20);
  let t0;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path fillRule="evenodd" clipRule="evenodd" d="M10.625 7C10.625 6.65482 10.3452 6.375 10 6.375C9.65482 6.375 9.375 6.65482 9.375 7C9.375 8.31168 8.31168 9.375 7 9.375C6.65482 9.375 6.375 9.65482 6.375 10C6.375 10.3452 6.65482 10.625 7 10.625C8.31168 10.625 9.375 11.6883 9.375 13C9.375 13.3452 9.65482 13.625 10 13.625C10.3452 13.625 10.625 13.3452 10.625 13C10.625 11.6883 11.6883 10.625 13 10.625C13.3452 10.625 13.625 10.3452 13.625 10C13.625 9.65482 13.3452 9.375 13 9.375C11.6883 9.375 10.625 8.31168 10.625 7Z" fill="url(#paint0_radial_18_3908)" />;
    t1 = <path d="M10 3.50439V4.44439" stroke="url(#paint1_linear_18_3908)" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />;
    t2 = <path d="M5.40674 5.40662L6.07174 6.07162" stroke="url(#paint2_linear_18_3908)" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />;
    t3 = <path d="M3.50446 9.99994H4.44446" stroke="url(#paint3_linear_18_3908)" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />;
    t4 = <path d="M5.40674 14.5933L6.07174 13.9283" stroke="url(#paint4_linear_18_3908)" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />;
    t5 = <path d="M10 16.4955V15.5555" stroke="url(#paint5_linear_18_3908)" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />;
    t6 = <path d="M14.5933 14.5933L13.9283 13.9283" stroke="url(#paint6_linear_18_3908)" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />;
    t7 = <path d="M16.4955 9.99994H15.5555" stroke="url(#paint7_linear_18_3908)" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />;
    t8 = <path d="M14.5933 5.40662L13.9283 6.07162" stroke="url(#paint8_linear_18_3908)" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />;
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
    $[5] = t5;
    $[6] = t6;
    $[7] = t7;
    $[8] = t8;
  } else {
    t0 = $[0];
    t1 = $[1];
    t2 = $[2];
    t3 = $[3];
    t4 = $[4];
    t5 = $[5];
    t6 = $[6];
    t7 = $[7];
    t8 = $[8];
  }
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <radialGradient id="paint0_radial_18_3908" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(10 10) rotate(90) scale(3.5 3.6582)"><stop stopColor="#5792FF" /><stop offset="1" stopColor="#2470FF" /></radialGradient>;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <linearGradient id="paint1_linear_18_3908" x1="10" y1="5" x2="10" y2="3" gradientUnits="userSpaceOnUse"><stop stopColor="#2470FF" /><stop offset="1" stopColor="#5792FF" /></linearGradient>;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  let t11;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <linearGradient id="paint2_linear_18_3908" x1="5" y1="5" x2="6.5" y2="6.5" gradientUnits="userSpaceOnUse"><stop stopColor="#5792FF" /><stop offset="1" stopColor="#2470FF" /></linearGradient>;
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  let t12;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <linearGradient id="paint3_linear_18_3908" x1="3" y1="10" x2="5" y2="10" gradientUnits="userSpaceOnUse"><stop stopColor="#5792FF" /><stop offset="1" stopColor="#2470FF" /></linearGradient>;
    $[12] = t12;
  } else {
    t12 = $[12];
  }
  let t13;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <linearGradient id="paint4_linear_18_3908" x1="5" y1="15" x2="6.5" y2="13.5" gradientUnits="userSpaceOnUse"><stop stopColor="#5792FF" /><stop offset="1" stopColor="#2470FF" /></linearGradient>;
    $[13] = t13;
  } else {
    t13 = $[13];
  }
  let t14;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <linearGradient id="paint5_linear_18_3908" x1="10" y1="15" x2="10" y2="17" gradientUnits="userSpaceOnUse"><stop stopColor="#2470FF" /><stop offset="1" stopColor="#5792FF" /></linearGradient>;
    $[14] = t14;
  } else {
    t14 = $[14];
  }
  let t15;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <linearGradient id="paint6_linear_18_3908" x1="15" y1="15" x2="13.5" y2="13.5" gradientUnits="userSpaceOnUse"><stop stopColor="#5792FF" /><stop offset="1" stopColor="#2470FF" /></linearGradient>;
    $[15] = t15;
  } else {
    t15 = $[15];
  }
  let t16;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <linearGradient id="paint7_linear_18_3908" x1="15" y1="10" x2="17" y2="10" gradientUnits="userSpaceOnUse"><stop stopColor="#2470FF" /><stop offset="1" stopColor="#5792FF" /></linearGradient>;
    $[16] = t16;
  } else {
    t16 = $[16];
  }
  let t17;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <defs>{t9}{t10}{t11}{t12}{t13}{t14}{t15}{t16}<linearGradient id="paint8_linear_18_3908" x1="15" y1="5" x2="13.5" y2="6.5" gradientUnits="userSpaceOnUse"><stop stopColor="#5792FF" /><stop offset="1" stopColor="#2470FF" /></linearGradient></defs>;
    $[17] = t17;
  } else {
    t17 = $[17];
  }
  let t18;
  if ($[18] !== props) {
    t18 = <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>{t0}{t1}{t2}{t3}{t4}{t5}{t6}{t7}{t8}{t17}</svg>;
    $[18] = props;
    $[19] = t18;
  } else {
    t18 = $[19];
  }
  return t18;
};
export default PointsGradient;